<mat-toolbar>
  <mat-toolbar-row>
    <h1 translate class="loren-role-form-title">
      <span>{{ "roles.new" | transloco }}</span>
      <button mat-icon-button (click)="handleBackClick()">
        <mat-icon class="loren-role-form-close">close</mat-icon>
      </button>
    </h1>
  </mat-toolbar-row>
</mat-toolbar>

@if (role$ | async; as role) {
  <div class="p-3">
    <mat-form-field class="w-100 mb-3 loren-form-field">
      <mat-label>{{ "roles.name" | transloco }}</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="role.name"
        placeholder="{{ 'roles.name' | transloco }}"
        [required]="true"
        />
      @if (role.name) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="role.name = ''"
          >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
    <div class="loren-role-form-privileges text-muted">
      {{ "roles.privileges" | transloco }}
    </div>
    <mat-divider></mat-divider>
    @for (privilege of role.entityPrivileges; track privilege) {
      <div class="text-muted">
        {{ translations.get(privilege.entity) | transloco }}
      </div>
      <div class="p-3">
        <mat-form-field style="width: 200px" class="loren-form-field">
          <mat-select [(ngModel)]="privilege.access">
            <mat-option value="READ">{{ "roles.read" | transloco }}</mat-option>
            <mat-option value="READ_WRITE"
              >{{ "roles.read" | transloco }} &
              {{ "roles.write" | transloco }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <mat-divider></mat-divider>
      }
      @if (!role.readonly) {
        <div class="loren-role-form-actions" *lorenShowForPrivileges="[privileges.WRITE_ROLE]">
          <button
            mat-stroked-button
            color="primary"
            class="mt-3 mb-3"
            (click)="saveRole(role)"
            >
            {{ "operations.save" | transloco }}
          </button>
          <button
            mat-button
            color="warn"
            class="mt-3 mb-3 ml-3"
            (click)="delete(role)"
            >
            {{ "operations.delete" | transloco }}
          </button>
        </div>
      }
    </div>
  }
